import { createSlice } from "@reduxjs/toolkit";
import { fetchSurveyQuestions } from "redux/actions/survey/surveyAction";

const initialState = {
  surveyQuestionListLoading: false,
  surveyQuestionList: [],
  surveyQuestionListTotalCount: 0,
  surveyQuestionListError: false,
  nextSurveyQuestionId: 0,
  surveyQuestionDetails: {},
};

export const surveyQuestion = createSlice({
  name: "surveyQuestion",
  initialState,
  reducers: {
    resetState: () => initialState,
    setNextSurveyQuestionId: (state, { payload }) => {
      state.nextSurveyQuestionId = payload;
    },
    setSurveyQuestionDetails: (state, { payload }) => {
      state.surveyQuestionDetails = payload;
    },
  },
  extraReducers: {
    [fetchSurveyQuestions.pending]: (state) => {
      state.surveyQuestionListLoading = true;
    },
    [fetchSurveyQuestions.fulfilled]: (state, { payload }) => {
      state.surveyQuestionList = payload?.results;
      state.surveyQuestionListTotalCount = payload?.count;
      state.surveyQuestionListLoading = false;
    },
    [fetchSurveyQuestions.rejected]: (state) => {
      state.surveyQuestionListLoading = false;
      state.surveyQuestionListError = true;
    },
  },
});

export const { resetState, setNextSurveyQuestionId, setSurveyQuestionDetails } =
  surveyQuestion.actions;

export default surveyQuestion.reducer;
